import classnames from "classnames";
import React from "react";
import { SanityImage, SanityRawContent } from "../../model/common";
import { imageUrlBuilder } from "../../utils/images";
import LandingPageSectionCard from "../LandingPageSectionCard/LandingPageSectionCard";
import styles from "./ImageGradientBlock.module.scss";
import { Col, Row } from "../Grid";

interface ImageGradientBlockProps {
  image: SanityImage;
  content: SanityRawContent;
  imageSide: "left" | "right";
  color: "red" | "blue" | "green";
  dir?: "ltr" | "rtl";
}

const ImageGradientBlock = ({
  color,
  content,
  image,
  imageSide,
  dir
}: ImageGradientBlockProps) => {
  return (
    <Row className={classnames(styles.row, styles[imageSide])} dir={dir}>
      <div
        className={classnames(
          styles[imageSide],
          styles[color],
          styles.gradient
        )}
      >
        <div className={styles.contentWrapper}>
          <LandingPageSectionCard
            className={styles.content}
            content={content}
          />
        </div>
        <div className={classnames(styles.triangle, styles[imageSide])} />
      </div>
      <Col className={styles.image} md={7} xs={12}>
        <img
          loading="lazy"
          alt={image.alt}
          src={
            imageUrlBuilder
              .image(image)
              .ignoreImageParams()
              .width(991)
              .url()!
          }
        />
      </Col>
    </Row>
  );
};

export default ImageGradientBlock;
